import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthAdapterService } from 'src/app/infraestructure/adapters/auth-adapter.service';
import { Auth } from '../../domain/models/auth.model';
import { BaseResponse } from '../../domain/models/base-response.model';
import { IDisplayerAuth } from '../../domain/ports/i-displayer-auth';

@Injectable({
  providedIn: 'root'
})
export class AuthDisplayerService implements IDisplayerAuth {

  constructor( private authAdapterService: AuthAdapterService ) { }

  askAuth(userName: string, userPassword: string): Observable<Auth>{
    return this.authAdapterService.postAuth(userName, userPassword);
  }

  askForgotPassword(userName: string): Observable<BaseResponse>{
    return this.authAdapterService.postForgotPassword(userName);
  }

  askPasswordRecovery(password: string, confirmPassword: string, token: string): Observable<Auth>{
    return this.authAdapterService.postPasswordRecovery(password, confirmPassword, token);
  }

}
